export const AUDIENCE_WEIGHTS = {
	low: [50, 99],
	medium: [100, 149],
	high: [150],
}

export const STORAGE_KEY = 'z_visitor';